import { sendToApi } from 'api/client'
import { UserAppPreferences } from 'types'

export const getUserAppPreferences = (workspaceId: Number) => {
  const url = `/user_app_preferences?workspace_id=${workspaceId}`

  return sendToApi<UserAppPreferences>(url, {
    method: 'GET',
  })
}

export const updateUserAppPreferences = (preferences: UserAppPreferences) => {
  return sendToApi('/user_app_preferences', {
    method: 'PUT',
    body: { preferences },
  })
}
